<!-- <h2 mat-dialog-title>Install Angular</h2> -->
<div mat-dialog-content class="mat-typography">
  <div class="row">
    <div class="col-md-12 text-center mb-5">
      <div class="d-flex flex-column align-items-center">
        <img
          src="{{ imageLink }}/personals/{{ image }}"
          class="avatar-lg rounded-circle"
          alt=""
        />
        <h2 class="mb-0">{{ name }}</h2>
        <h4 class="mb-3 text-secondary">{{ designation }}</h4>
        <span>{{ biography }}</span>
      </div>
    </div>
  </div>
  <div class="col-md-9">
    <div class="col-12"></div>
  </div>
</div>


<!-- Copyright 2020 Google LLC. All Rights Reserved.
    Use of this source code is governed by an MIT-style license that
    can be found in the LICENSE file at http://angular.io/license -->
